/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button, Row, Col, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

const { Title } = Typography;

const styles = {
  title: {
    fontWeight: "400",
    fontSize: "18px",
    color: "#404047",
    margin: 0,
    marginBottom: 8,
    lineHeight: '29px',
    textAlign: 'center'
  },
  subtitle: {
    fontWeight: "300",
    fontSize: "12px",
    lineHeight: "20px",
    textAlign: "center",
    letterSpacing: "0.02em",
    color: "#8C8C8C"
  }
}

const MobileHeaderBack = ({previousPage, text, title, subtitle}) => {
  const { t } = useTranslation(['speak-doctor']);
  const history = useHistory();

  const onBack = () => {
    history.push(previousPage)
  }

  const renderBack = () => {
    if (previousPage === "") {
      return <p style={styles.rowButton}>{t(text)}</p>
    }

    return (
      <Button type="link" onClick={onBack}>
        <p style={styles.rowButton}>
          <ArrowLeftOutlined style={{ color: '#15A9E1', marginRight: 10 }} /> {t(text)}
        </p>
      </Button>
    )
  }

  return (
    <>
      <Row justify="center" style={{ padding: 0, marginBottom: 50 }}>
        <Col>
          {renderBack()}
        </Col>
      </Row>
      <Row justify="center" style={{ padding: 0, marginBottom: 28 }}>
        <Col>
          <Title level={4} style={styles.title}>
            {t(title)}
          </Title>
          {
            subtitle !== '' && <p style={styles.subtitle}>{t(subtitle)}</p>
          }
        </Col>
      </Row>
    </>
  );
}

MobileHeaderBack.defaultProps = {
  previousPage: "",
  text: "",
  title: "",
  subtitle: ""
};

const { string } = PropTypes;

MobileHeaderBack.propTypes = {
  previousPage: string,
  text: string,
  title: string,
  subtitle: string
};

export default MobileHeaderBack;
